import { useState } from 'react'
import {
  entityCampaignId,
  entityLeadSourceId,
  entityReferral,
} from '@user/components/Settings/EntityFormSettings'
import type { FieldSettingsMap } from '@user/store/entityFormSettings'
import { useFormikContext } from 'formik'
import { ILeadFormModel } from '../../../typings'

type Props = {
  settingsMap: FieldSettingsMap
}

export function useData(props: Props) {
  const { settingsMap } = props

  const [campaignDisabled, setCampaignDisabled] = useState(false)

  const [requiredCampaignId, showCampaign] = settingsMap.get(
    entityCampaignId,
  ) ?? [false, true]
  const [requiredLeadSourceId, showLeadSource] = settingsMap.get(
    entityLeadSourceId,
  ) ?? [false, true]
  const [requiredReferral, showReferral] = settingsMap.get(entityReferral) ?? [
    false,
    true,
  ]

  const {
    errors,
    touched,
    values: { callTrackingActivity, campaignId, leadSourceId },
  } = useFormikContext<ILeadFormModel>()

  return {
    campaignDisabled,
    setCampaignDisabled,
    requiredCampaignId,
    showCampaign,
    requiredLeadSourceId,
    showLeadSource,
    requiredReferral,
    showReferral,
    errors,
    touched,
    callTrackingActivity,
    campaignId,
    leadSourceId,
  }
}

export type UseData = ReturnType<typeof useData>
